import Vue from "vue";

export const state = {
  cart: [],
  lastPurchase: []
};

export const mutations = {
  ADD_TO_CART(state, item) {
    Vue.set(item, "new_pass", {
      name: "",
      price: 0,
      type: "none"
    });
    state.cart.push(item);
  },
  ADD_ALL_TO_CART(state, items) {
    items.forEach(item => {
      Vue.set(item, "new_pass", {
        name: "",
        price: 0,
        type: "none"
      });
    });

    state.cart = state.cart.concat(items);
  },
  SET_CART(state, items) {
    items.forEach(item => {
      if (!item.new_pass) {
        Vue.set(item, "new_pass", {
          name: "",
          price: 0,
          type: "none"
        });
      }
    });

    state.cart = items;
  },
  REMOVE_FROM_CART(state, index) {
    state.cart.splice(index, 1);
  },
  REMOVE_ITEM_FROM_CART(state, item) {
    state.cart.splice(
      state.cart.findIndex(i => i.id === item.id),
      1
    );
  },
  CLEAR_CART(state) {
    state.cart = [];
  },

  SET_LAST_PURCHASE(state, passes) {
    state.lastPurchase = passes;
  }
};

export const actions = {
  addToCart({ commit }, item) {
    commit("ADD_TO_CART", item);
  },
  addAllToCart({ commit }, items) {
    commit("ADD_ALL_TO_CART", items);
  },
  setCart({ commit }, items) {
    commit("SET_CART", items);
  },
  removeFromCart({ commit }, index) {
    commit("REMOVE_FROM_CART", index);
  },
  removeItemFromCart({ commit }, item) {
    commit("REMOVE_ITEM_FROM_CART", item);
  },
  clearCart({ commit }) {
    commit("CLEAR_CART");
  },

  setLastPurchase({ commit }, passes) {
    commit("SET_LAST_PURCHASE", passes);
  }
};
export const getters = {
  cart: state => {
    return state.cart;
  },
  cartSize: state => {
    return state.cart.length;
  },
  cartTotal: state => {
    return state.cart.reduce((sum, item) => {
      return sum + item.new_pass.price;
    }, 0);
  },
  cartCanPurchase(state, getters, rootState, rootGetters) {
    if (getters.cartSize === 0) return false;

    return getters.cart.every(item => {
      return rootGetters.passTypes.some(type => {
        return type.id === item.new_pass.type;
      });
    });
  },

  lastPurchase: state => {
    return state.lastPurchase;
  }
};
